import TaskForm, { TaskField } from "../TaskForm";
import ParcelService from "../../../services/parcelService";
import { SeedTask } from "../../../interfaces/SeedTask";

interface CreateEntryFormProps {
    onSave: (newEntry: SeedTask) => void;
    parcelId: number;
    cycleId: number;
    isNew: boolean;
    task?: SeedTask;
    readOnly?: boolean;
}

export default function SeedCreateForm(props: CreateEntryFormProps) {
    const parcelService = new ParcelService();

    const fields: TaskField[] = [
        { name: "date", label: "Datum", type: "date", required: true },
        { name: "kind", label: "Sorte", type: "text", required: true },
        { name: "quantity", label: "Menge (pro/ha)", type: "number", required: true },
        { name: "note", label: "Notizen", type: "textarea" }
    ] as const;

    const defaultState: SeedTask = {
        id: "",
        date: new Date(),
        kind: "",
        quantity: 0,
        note: ""
    };

    return (
        <TaskForm<SeedTask>
            title="Saat"
            fields={fields}
            isNew={props.isNew}
            task={props.task}
            defaultState={defaultState}
            onSubmit={async (data) => {
                if (props.isNew) {
                    await parcelService.createSeedTask(props.parcelId, props.cycleId, data);
                } else {
                    await parcelService.updateSeedTask(props.parcelId, props.cycleId, Number(data.id), data);
                }
                await props.onSave(data);
            }}
            readOnly={props.readOnly}
        />
    );
}
